export function scrollPageToTop() {
  if (typeof window === "undefined") return

  const currentDocument = typeof document === "undefined" ? null : document

  scrollTargetToTop(window)
  scrollTargetToTop(currentDocument?.scrollingElement)
  scrollTargetToTop(currentDocument?.querySelector?.(".page-scroll"))
  scrollTargetToTop(currentDocument?.querySelector?.(".context-frame-body"))
}

function scrollTargetToTop(target) {
  if (!target) return

  if (typeof target.scrollTo === "function") {
    target.scrollTo({ top: 0, left: 0, behavior: "auto" })
  } else {
    target.scrollTop = 0
    target.scrollLeft = 0
  }
}
